<app-nav></app-nav>
<div class="new-home-page">
  <duv class="container">
    <!-- <div class="home-tabs">
      <ul>
        <li (click)="buyReferPart=true;viewClaimsPart=false;" [ngClass]="{ 'active': buyReferPart}">Buy & Refer</li>
        <li (click)="buyReferPart=false;viewClaimsPart=true;" [ngClass]="{'active': viewClaimsPart}">Policies & Claims
        </li>
      </ul>
    </div> -->
    <section class="buy-refer">

      <div class="image-part desktop-hide">
        <div id="productSlider" class="carousel slide" data-ride="carousel" data-interval="2000">
          <ol class="carousel-indicators">
            <!-- <li data-target="#productSlider" data-slide-to="0" class="active"></li> -->
            <li data-target="#productSlider" data-slide-to="1" class="active"></li>
            <li data-target="#productSlider" data-slide-to="2"></li>
            <li data-target="#productSlider" data-slide-to="3"></li>
            <li data-target="#productSlider" data-slide-to="4"></li>
            <!-- <li data-target="#productSlider" data-slide-to="5"></li> -->
            <li data-target="#productSlider" data-slide-to="5"></li>
            <li data-target="#productSlider" data-slide-to="6"></li>
            <!-- <li data-target="#productSlider" data-slide-to="7"></li> -->
          </ol>
          <div class="carousel-inner">
            <!-- <div class="carousel-item active">
              <a (click)="createProspectForTopUp()">
                <img src="assets/images/first-month-banner.jpg" class="bottom" />
              </a>
            </div> -->
            <!-- <div class="carousel-item active">
              <img src="assets/images/Surgical Care.jpg" routerLink="/surgical-care" class="bottom" />
            </div> -->
            <div class="carousel-item active" routerLink="/poly-clinic">
              <img src="assets/images/Poly Clinic.jpg" class="bottom" />
            </div>
            <div class="carousel-item">
              <img src="assets/images/fhi-banner.jpg" routerLink="/family-health-insurance" class="bottom" />
            </div>
            <div class="carousel-item" (click)="createProspectForMotor()">
              <img src="assets/images/motor-banner.jpg" class="bottom" />
            </div>
            <div class="carousel-item">
              <img src="assets/images/pa-banner.jpg" routerLink="/personal-accident" class="bottom" />
            </div>
            <div class="carousel-item">
              <img src="assets/images/dpi-banner.jpg" routerLink="/doctor-professional-indemnity" class="bottom" />
            </div>
            <!-- <div class="carousel-item" (click)="createProspectForHomeLoan()">
              <a href="https://www.myloancare.in/home-loan-interest-rates/?utm_source=securenow_app&utm_medium=app_banner&utm_campaign=home_loan_interest_rates"
                target="_blank">
                <img src="assets/images/home-loan-banner.jpg" class="bottom" />
              </a>
            </div> -->
            <div class="carousel-item" (click)="createProspectForMaxLife()">
              <a routerLink="/term-life-info">
                <img src="assets/images/term-life-banner.jpg" class="bottom" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <img src="assets/images/BackArrow.svg" width="45px" class="m-1" style="cursor: pointer;" *ngIf="showBackBtn" (click)="backFunction()" />
      <div class="content-box btm-margin bbtm0">
        <h4>View</h4>
        <div class="row">
          <div *ngIf="showYourPolicies" class="cols-3 text-center">
            <div class="product-icon" (click)="saveClickEvent('Your-Policies')" routerLink="/yourPolicies">
              <span class="icon icon-policy"></span>
            </div>
            <div><label class="product-title" >Your Policies</label></div>
          </div>
          <div class="cols-3 text-center">
            <div class="product-icon" (click)="saveClickEvent('E-Cards')" routerLink="/e-cards">
              <span class="icon icon-card"></span>
            </div>
            <!-- <div><label class="product-title">Health E-Cards</label></div> -->
            <div><label class="product-title">Group Policy E-cards</label></div>
          </div>
          <div class="cols-3 text-center">
            <div class="product-icon" routerLink="/hospitalLocator">
              <span class="icon icon-hospital"></span>
            </div>
            <div><label class="product-title">Hospital Locator</label></div>
          </div>
          <div class="cols-3 text-center">
            <div class="product-icon" routerLink="/add-policy">
              <span class="icon icon-add-policy"></span>
            </div>
            <div><label class="product-title">Add Policy</label></div>
          </div>
          <div class="cols-3 text-center">
            <div class="product-icon"  routerLink="/requested-quotes">
              <span class="icon your-quotes"></span>
            </div>
            <div><label class="product-title" >Your Quotes</label></div>
          </div>
        </div>
      </div>
      <div class="content-box bbtm0 btm-margin">
        <h4>Claim</h4>
        <div class="row">
          <div class="cols-3 text-center">
            <div class="product-icon" routerLink="/register">
              <span class="icon icon-intimate"></span>
            </div>
            <div><label class="product-title">Register</label></div>
          </div>
          <div class="cols-3 text-center">
            <div class="product-icon" routerLink="/submit">
              <span class="icon icon-submit"></span>
            </div>
            <div><label class="product-title">Submit</label></div>
          </div>
          <div class="cols-3 text-center">
            <div class="product-icon" routerLink="/status">
              <span class="icon icon-status"></span>
            </div>
            <div><label class="product-title">Check Status</label></div>
          </div>
          <!-- <div class="cols-3 text-center">
            <div class="product-icon" (click)="checKClaimsFAQ()">
              <span class="icon icon-claims-faq"></span>
            </div>
            <div><label class="product-title">Claims FAQ</label></div>
          </div> -->
        </div>
      </div>

      <ng-container *ngIf="showSecurenowFacilities">
      <div class="content-box bbtm0 btm-margin">
        <h4>Treatment</h4>
        <div class="row productCard1">
          <!-- <div class="cols-3" (click)="saveClickEvent('Surgical-Care')" routerLink="/surgical-care">
            <div class="product-icon">
              <span class="icon icon-surgicalCare"></span>
            </div>
            <div class="text-center"><label class="product-title">Surgical Care</label></div>
          </div> -->

          <div class="cols-3 box-margin" (click)="saveClickEvent('Poly-Clinic')" routerLink="/poly-clinic">
            <div class="product-icon">
              <span class="icon icon-polyclinic"></span>
            </div>
            <div class="text-center"><label class="product-title">Poly Clinic</label></div>
          </div>
          <!-- <div class="cols-3 box-margin" (click)="redirectToMedPay()">
            <span class="special mfine-off-span"> 10% off</span>  
              <div class="product-icon">
                <span class="icon icon-medpay"></span>
              </div>
              <div class="text-center"><label class="product-title">Discounted Pharmacy</label></div>
          </div> -->

          
          <!-- <div class="col-3 productCard" (click)="redirectToRedCliffe()">        -->
            <div class="cols-3 box-margin" routerLink="/healthPackage">   
              <div class="product-icon">
                <span class="icon icon-redCliffe"></span>
              </div>
              <div class="text-center"><label class="product-title">Health Checkup</label></div>
            </div>

            <!-- Hide Cosmetic Surgery Icon Asked By Saurabh -->
            <!-- <div class="cols-3" (click)="saveClickEvent('Cosmetic-Care')" routerLink="/cosmetic-surgery">
              <div class="product-icon">
                <span class="icon icon-cosmetic"></span>
              </div>
              <div class="text-center"><label class="product-title">Cosmetic Surgery</label></div>
            </div> -->

            <!-- <div class="cols-3 box-margin" (click)="redirectToMfine()">  
              <span class="special mfine-off-span"> 15% off</span>      
                <div class="product-icon">
                  <span class="icon icon-homeloan"></span>
                </div>
                <div class="text-center"><label class="product-title">Discounted Specialist Consultation</label></div>
            </div> -->
  
            
            <div *ngIf="showMFineFGPC" class="cols-3 box-margin" (click)="redirectToFreeGeneralConsultaion('SECURE-NOW-GP')">   
              <span class="special mfine-off-span"> Free </span>  
                <div class="product-icon">
                  <span class="icon icon-mfineGPC"></span>
                </div>
                <div class="text-center"><label class="product-title">General Physician Consultation</label></div>
            </div>
         
            
            <div *ngIf="showMFineFreeSpecialist" class="cols-3 box-margin" (click)="getVisitTeleConsultation('SECURE-NOW-SP')">   
              <span class="special mfine-off-span"> Free </span>  
              <div class="product-icon">
                  <span class="icon icon-mfineFreeSpecialist"></span>
                </div>
                <div class="text-center"><label class="product-title">Specialist Consultation</label></div>
            </div>

            <div *ngIf="showPsychiatrist" class="cols-3 box-margin" (click)="getVisitPsychiatrist('SECURE-NOW-PY')">   
              <span class="special mfine-off-span"> Free </span>  
              <div class="product-icon">
                  <span class="icon icon-psychiatrist"></span>
                </div>
                <div class="text-center"><label class="product-title">Psychiatrist Consultation</label></div>
            </div>

          <div class="cols-3 box-margin" (click)="corporateHealthCheckup('SECURE-NOW-AHC')" *ngIf="isCorporateHealthCheckupRestricted">
              <div class="product-icon">
                <span class="icon corporate-health-checkup"></span>
              </div>
              <div class="text-center"><label class="product-title">Corporate Health Checkup</label></div>
            </div>
          
          <div class="cols-3 box-margin" routerLink="/hra-calculator">
              <div class="product-icon">
                <span class="icon hra-calculator"></span>
              </div>
              <div class="text-center"><label class="product-title">Health Risk Assessment</label></div>
            </div>

          <div class="cols-3 box-margin" [routerLink]="['/poly-clinic']" [queryParams]="{ service: 'mentalHealth' }">
              <div class="product-icon">
                <span class="icon mental-health"></span>
              </div>
              <div class="text-center"><label class="product-title">Mental Health</label></div>
            </div>

        </div>
      </div>

      <div class="buy-part">
        <div class="content-box btm-margin"> 
          <h4>Buy</h4>
          <div class="row mt-2">
            <div class="cols-3 no-padding" routerLink="/family-health-insurance">
              <div class="product-icon">
                <span class="icon icon-fhi"></span>
              </div>
              <div class="text-center"><label class="product-title">Health Insurance</label></div>
            </div>
            <div class="cols-3 no-padding" (click)="createProspectForMotor()">
              <div class="product-icon">
                <span class="icon icon-motor"></span>
              </div>
              <div class="text-center"><label class="product-title">Motor Insurance</label></div>
            </div>
            <div class="cols-3" routerLink="/personal-accident">
              <span class="special"><img
                  src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/special-icon.svg">
                SPECIAL</span>
              <div class="product-icon">
                <span class="icon icon-pa"></span>
              </div>
              <div class="text-center"><label class="product-title">Personal Accident</label></div>
            </div>
            <div class="cols-3" routerLink="/doctor-professional-indemnity">
              <div class="product-icon">
                <span class="icon icon-dpi"></span>
              </div>
              <div class="text-center"><label class="product-title">Doctor's Indemnity</label></div>
            </div>

            <div class="cols-3 productCard1">
              <a routerLink="/term-life-info">
                <div class="product-icon">
                  <span class="icon icon-max-life"></span>
                </div>
                <div class="text-center"><label class="product-title">Term Life</label></div>
              </a>
            </div>

            <div class="cols-3 productCard" routerLink="/daily-hospital-cash">
              <div class="product-icon">
                <span class="icon icon-hospital-cash"></span>
              </div>
              <div class="text-center"><label class="product-title">Hospital Cash</label></div>
            </div>

            <div class="cols-3 productCard" (click)="routeSeniorCitizenInsurance()">
              <div class="product-icon">
                <span class="icon icon-senior-citizen"></span>
              </div>
              <div class="text-center"><label class="product-title">Senior Citizen Insurance</label></div>
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-3 productCard" (click)="createProspectForCovid()">
              <span class="new-product">NEW!</span>
              <div class="product-icon">
                <span class="icon icon-covid"></span>
              </div>
              <div class="text-center"><label class="product-title">Corona Kavach</label></div>
            </div> -->
            <!-- <div class="col-3 productCard" (click)="healthAssureUpdate()">
              <span class="new-product">
                NEW!</span>
              <div class="product-icon">
                <span class="icon icon-opd"></span>
              </div>
              <div class="text-center"><label class="product-title">Health Services</label></div>
              <div class="subtitle"><label class="product-subTitle">by HealthAssure</label></div>
            </div> -->

            <!-- <div class="col-3 productCard" (click)="openMedPay()">
              <div class="product-icon">
                <span class="icon icon-medpay"></span>
              </div>
              <div class="text-center"><label class="product-title">MedPay</label></div>
            </div> -->

            <!-- <div class="col-3 productCard" (click)="createProspectForTopUp()">
              <div class="product-icon">
                <span class="icon icon-top-up"></span>
              </div>
              <div class="text-center"><label class="product-title">Top-up Health cover</label></div>
            </div> -->
          </div>
        </div>
      </div>
    </ng-container>
      <div class="content-box buy-part desktop-hide">
        <div class="insuropedia-box">
          <div>
          <h6 class="heading"><b>Insuropedia</b></h6>
        </div>
          <p style="color: black;">Insurance queries and answers at one place</p>
            <form class="search-container" name="form" #f="ngForm" ng-submit="searchInsuropediaResult(searchContent)">
              <input type="text" id="search-bar" placeholder="Ask anything related to insurance" [(ngModel)]="searchContent"
                name="searchContent">
              <input type="submit" (click)="searchInsuropediaResult(searchContent)" class="search-icons" value="">
            </form>
         
        </div>
      </div>

      <div class="buy-part desktop-hide">
        <div class="content-box bbtm0">
          <h4>Refer & Earn</h4>
          <div class="image-part">
            <div id="referSlider" class="carousel slide" data-ride="carousel" data-interval="2000">
              <ol class="carousel-indicators">
                <!-- <li data-target="#referSlider" data-slide-to="0" class="active"></li>
                <li data-target="#referSlider" data-slide-to="1"></li> -->
              </ol>
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img src="assets/images/refer1.jpg" routerLink="/refer" class="bottom" />
                </div>
                <!-- <div class="carousel-item">
                  <img src="assets/images/refer2.jpg" routerLink="/articles" class="bottom" />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section class="view-claim" *ngIf="viewClaimsPart">
      <div class="content-box btm-margin bbtm0">
        <h4>View</h4>
        <div class="row">
          <div class="col-3 text-center">
            <div class="product-icon" routerLink="/yourPolicies">
              <span class="icon icon-policy"></span>
            </div>
            <div><label class="product-title">Your Policies</label></div>
          </div>
          <div class="col-3 text-center">
            <div class="product-icon" routerLink="/e-cards">
              <span class="icon icon-card"></span>
            </div>
            <div><label class="product-title">E-Cards</label></div>
          </div>
          <div class="col-3 text-center">
            <div class="product-icon" routerLink="/hospitalLocator">
              <span class="icon icon-hospital"></span>
            </div>
            <div><label class="product-title">Hospital Locator</label></div>
          </div>
          <div class="col-3 text-center">
            <div class="product-icon" routerLink="/add-policy">
              <span class="icon icon-add-policy"></span>
            </div>
            <div><label class="product-title">Add Policy</label></div>
          </div>
        </div>
      </div>
      <div class="content-box bbtm0 btm-margin">
        <h4>Claim</h4>
        <div class="row">
          <div class="col-3 text-center">
            <div class="product-icon" routerLink="/register">
              <span class="icon icon-intimate"></span>
            </div>
            <div><label class="product-title">Register</label></div>
          </div>
          <div class="col-3 text-center">
            <div class="product-icon" routerLink="/submit">
              <span class="icon icon-submit"></span>
            </div>
            <div><label class="product-title">Submit</label></div>
          </div>
          <div class="col-3 text-center">
            <div class="product-icon" routerLink="/status">
              <span class="icon icon-status"></span>
            </div>
            <div><label class="product-title">Check Status</label></div>
          </div>
        </div>
      </div>
    </section> -->
  </duv>
</div>

<div class="fixed-footer col">
  <div class="row footer-body">
    <div class="col text-center p-0" routerLink="/home"><img
        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Home-fill.svg"
        class="img img-fluid" alt=""></div>
    <div class="col text-center p-0"><a (click)="callNow()"><img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone-bordered.svg"
          class="img img-fluid" alt=""></a></div>
    <div class="col text-center p-0" routerLink="/email"><img
        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/email-bordered.svg"
        class="img img-fluid" alt=""></div>
    <div class="col text-center p-0" routerLink="/profile"><img
        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Profile-bordered.svg"
        class="img img-fluid" alt=""></div>

  </div>
</div>
<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>